module.exports = __webpack_public_path__ + "img/fono.a989a8e0.svg";